import { TStyles } from "utils/Styles";

const styles: TStyles = {
  textfield: {
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      backgroundColor: (theme) => theme.palette.background.paper,
      px: 0.25,
    },

    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink) + .MuiInputBase-root .MuiOutlinedInput-notchedOutline legend":
      {
        width: 0,
        maxWidth: 0,
        padding: 0,
      },

    "& .MuiInputBase-root.MuiInputBase-multiline > .MuiInputBase-input": {
      p: 0,
    },
  },
};

export default styles;
